import { alphabet } from "../../../constants/schulte-test";

export const shulteOptions = {
  symbols: [...alphabet, "к"],
  solution: ["а", "б", "в", "г", "д", "е", "ё", "ж", "з" ],
  rows: 5,
  cols: 7,
  withDot: true
};
